module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk og engelsk_primaerlogo_neg(hvit).1fd37c59.png";